function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Email Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.436,0.0004 C16.2994152,0.0004 17,0.700530172 17,1.5644 L17,11.1694 C17,12.033225 16.2994612,12.7324 15.436,12.7324 L1.564,12.7324 C0.700538768,12.7324 -6.77626358e-21,12.033225 -6.77626358e-21,11.1694 L-6.77626358e-21,1.5644 L0.000155316174,1.5519105 C0.000397582383,1.54350976 0.000851809197,1.53510571 0.001519649,1.52670665 L-6.77626358e-21,1.5644 C-6.77626358e-21,0.700530172 0.700584802,0.0004 1.564,0.0004 L15.436,0.0004 Z M15.9999473,2.4984 L8.7589066,7.31612047 C8.59084592,7.42790241 8.37205751,7.42767522 8.20422936,7.31554448 L0.999947328,2.5024 L1,11.1694 C1,11.4805036 1.25238776,11.7324 1.564,11.7324 L15.436,11.7324 C15.7476122,11.7324 16,11.4805036 16,11.1694 L15.9999473,2.4984 Z M15.436,1.0004 L1.564,1.0004 C1.33496256,1.0004 1.13762518,1.13713747 1.04933996,1.33345629 L8.48262401,6.29888602 L15.9502147,1.33246861 C15.8617125,1.13667901 15.6646531,1.0004 15.436,1.0004 Z",
  id: "email-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "email-Icon/Global/email",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "email-Swatches/Midnight",
  transform: "translate(4.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "email-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#email-path-1"
})));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.53dcedbb.svg";
export { ForwardRef as ReactComponent };